export default {
    state: () => ({
        data: {
            currentCityId: null,
            defaultCityId: 2182, // Kyiv by default (city ID in New Post list). According Technical Task - Kyiv is a default city.
        }
    }),
    mutations: {
        ['stores/setState'](state, payload) {
            state.data = {
                ...payload,
                currentCityId: state.data.currentCityId,
                defaultCityId: state.data.defaultCityId,
            };
        },
        ['stores/changeCurrentCityId'](state, payload) {
            state.data = { ...state.data, currentCityId: payload };
        },
    },
    actions: {
    },
    getters: {
        ['stores/getCurrentCityId']: ({ data: { currentCityId } }, rootGetters) => {
            return currentCityId ?? rootGetters['cities/id'];
        },
        ['stores/getActiveCityName']: ({ data: { cities, defaultCityId } }, getters) => {
            return cities?.find(el => el.ID == getters['stores/getCurrentCityId'])?.UF_NAME ??
                cities?.find(el => el.ID == defaultCityId)?.UF_NAME
        },
        ['stores/getActiveCity']: ({ data: { cities, defaultCityId } }, getters) => {
            return cities?.find(el => el.ID == getters['stores/getCurrentCityId']) ??
                cities?.find(el => el.ID == defaultCityId)
        },
        ['stores/getStoresFilteredByCity']: ({ data: { stores, defaultCityId } }, getters) => {
            let filteredStores = stores?.filter(el => el.cityId == getters['stores/getCurrentCityId']);
            /**
             * if there are no matches for the current city, need to select warehouses for the default city ( According Technical Task )
             */
            if (filteredStores?.length == 0) {
                filteredStores = stores?.filter(el => el.cityId == defaultCityId);
            }
            return filteredStores;
        },
        ['stores/getCities']: ({ data: { cities } }, getters) => {
            return cities?.map(el => {
                return {
                    ...el,
                    active: el.UF_NAME == getters['stores/getActiveCityName'],
                };
            }) || [];
        },
    }
}
